import jQuery from 'jquery';

export default {
  inserted(el) {
    jQuery(el).dropdown();
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/directives/dropdown.js